var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("ReprogramarCronograma"),
      _vm._v(" "),
      _c("AprobarReprogramacionVacacionSuperior"),
      _vm._v(" "),
      _c("RechazarReprogramacionVacacion"),
      _vm._v(" "),
      _c("VerDetalle"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Solicitud de vacación\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(items.item.secuencia) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nombre))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nombre_unidad))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.fecha_desde))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.fecha_hasta))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.total_dias))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.estado))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#3dca24",
                                    icon: "",
                                    title: "Ver detalle"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.verDetalle(items.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              ),
                              _vm._v(" "),
                              items.item.id_estado == 68 ||
                              items.item.id_estado == 69
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#44deaa",
                                        icon: "",
                                        title:
                                          "Enviar solicitud de uso de vacación"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.aprobarReprogramacionVacacionSuperior(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("send")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.estado == "Enviado Reprog."
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#FF5D34",
                                        icon: "",
                                        title: "Rechazar"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.rechazarReprogramacionJefeInmediato(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "warning",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.verReporte({}, 7)
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("picture_as_pdf")
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ver reporte")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eff063b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eff063b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_reprogramacion/VacacionReprogramacionJefeSuperior.vue
// module id = null
// module chunks = 